import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const CreateUpdatePolicyService = (type: number, content: string) => {
  return HTTP_CLIENT.post(`${Endpoint.policies.createUpdatePolicies}`, {
    type,
    content,
  });
};

const GetSinglePolicyService = (type: number) => {
  return HTTP_CLIENT.get(`${Endpoint.policies.getSinglePolicy}/${type}`);
};

export { CreateUpdatePolicyService, GetSinglePolicyService };
